import {Children, cloneElement} from "react";

export default function BoardingFlow({activeStep, children, ...otherProps}) {
    return cloneElement(Children.toArray(children)[activeStep], {...otherProps});
}
